'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'

interface Ambassador {
  image: string
  name: string
  title: string
}

export const MeetOurAmbassadors = () => {
  const isMobile = useIsMobileClient()
  const [carouselApi, setCarouselApi] = useState<CarouselApi | null>(null)
  const t = useTranslations('meet_our_ambassadors')

  // Auto play effect
  useEffect(() => {
    if (!carouselApi || ambassadors.length < 2) return
    const interval = setInterval(() => {
      if (carouselApi) {
        carouselApi.scrollNext()
      }
    }, 3000) // 3 seconds
    return () => clearInterval(interval)
  }, [carouselApi])

  return (
    <CollectionContainer>
      <div className='mb-4 flex items-center justify-between'>
        <p className='text-lg font-medium uppercase md:text-2xl'>
          {t('title')}
        </p>
        <Link
          href='/dai-su-the-thao?active-tab=sports-ambassador'
          className='hidden text-base underline md:block'
        >
          {t('see_more')}
        </Link>
      </div>

      {/* Ambassador Carousel */}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          skipSnaps: false,
          slidesToScroll: 1,
        }}
        setApi={setCarouselApi}
        className='w-full'
      >
        <CarouselContent className='-ml-4'>
          {ambassadors.map((ambassador, index) => (
            <CarouselItem
              key={index}
              className={cn(
                'cursor-pointer pl-4',
                isMobile ? 'basis-[66.666%]' : 'basis-1/4'
              )}
            >
              <div className='relative overflow-hidden rounded-lg'>
                <div className='aspect-[434/581]'>
                  <Image
                    src={ImageHelper.getImageUrlCdn(ambassador.image)}
                    alt={ambassador.name}
                    fill
                    className='h-full w-full object-cover'
                  />
                </div>
                <div className='absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent p-4 text-white'>
                  <h3 className='text-lg font-medium text-white'>
                    {ambassador.name}
                  </h3>
                  <p className='text-sm text-white opacity-90'>
                    {ambassador.title}
                  </p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        <CarouselNavigation />
      </Carousel>

      {/* Mobile view button */}
      <div className='mt-4 flex justify-center md:hidden'>
        <Link
          href='/dai-su-the-thao?active-tab=sports-ambassador'
          className='inline-block rounded-full border border-black px-8 py-2 text-center font-medium'
        >
          {t('see_more_mobile')}
        </Link>
      </div>
    </CollectionContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-auto w-auto -translate-y-1/2 rounded-full bg-black p-2 text-white md:-left-5 md:p-3'
        variant='outline'
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-auto w-auto -translate-y-1/2 rounded-full bg-black p-2 text-white md:-right-5 md:p-3'
        variant='outline'
      />
    </>
  )
}

const ambassadors: Ambassador[] = [
  {
    image: '/image/2026/03/09/S3xubLbTjor8T3xPtyflTtF5gaf.jpg',
    name: 'Lương Đức Phước',
    title: '"Chàng trai vàng" của điền kinh Việt Nam',
  },
  {
    image: '/image/2026/03/09/TvEubwHRfo5VgoxPC10l7J8fgwe.jpg',
    name: 'Nguyễn Thị Oanh',
    title: '"Nữ hoàng điền kinh" Việt Nam',
  },
  {
    image: '/image/2026/03/09/XIWNbJqawoxrqAxEdSOlJTq3gpc.jpg',
    name: 'Marco Phú Cường',
    title: 'Fitness Influencer, Người Mẫu',
  },
  {
    image: '/image/2026/03/09/CAd9beZcJoqR6jx2Vvnlm74Egoc.jpg',
    name: 'Sophia Phương Anh',
    title: 'VĐV Pickleball trẻ nhất Việt Nam vô địch thế giới',
  },
]
